import styled from 'styled-components';

export const PaymentLinkDetailsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const PaymentLinkDetailsListItem = styled.li`
  padding: 4px;
`;
